import React from 'react';
import styled from 'styled-components';
import { PodcastType } from '../../../types/Podcast';
import Image from '../../../components/ui/image/Image';
import ButtonLink from '../../../components/ui/link/ButtonLink';
import ShowMoreText from './ShowMoreText';

const Wrapper = styled.div`
	padding: 10px 20px;
	display: flex;
	flex-direction: row;
	background-color: var(--color-oxford-blue);
`;

const Details = styled.div`
	padding: 5px 15px;
	width: 100%;
`;

const Unsubscribe = styled.div`
	float: right;
	margin-top: 8px;
`;

const PodcastName = styled.h2`
	font-size: 18pt;
	font-weight: 500;
	color: var(--color-light-gray);
`;

const ArtistName = styled.h4`
	font-size: large;
	font-weight: 300;
	color: var(--color-light-gray);
`;

const Description = styled.div`
	font-size: large;
	font-weight: 300;
	margin-top: 25px;
`;

interface PodcastDetailsProps {
	podcast: PodcastType;
	onUnsubscribe: () => void;
}

const PodcastDetails: React.FC<PodcastDetailsProps> = ({
	podcast,
	onUnsubscribe
}) => {
	return (
		<Wrapper>
			<Image src={podcast.imageUrl} width="150px" height="150px" />
			<Details>
				<Unsubscribe>
					<ButtonLink onClick={onUnsubscribe}>Unsubscribe</ButtonLink>
				</Unsubscribe>
				<PodcastName>{podcast.podcastName}</PodcastName>
				<ArtistName>{podcast.artistName}</ArtistName>
				<Description>
					<ShowMoreText lines={2}>{podcast.description}</ShowMoreText>
				</Description>
			</Details>
		</Wrapper>
	);
};

export default PodcastDetails;
// File renamed to src/features/documents/components/PodcastDetails.tsx
